(function () {
  'use strict';
  var assets = window.IM_REFERENCE_ASSETS || {};
  var path = window.location.pathname.replace(/\/+$/, '');

  var optimizedNames = {
    home_hero_apparel_flatlay: ['01_home_hero_apparel_flatlay.png', 'modern_apparel_flat_lay_with_bold_graphics.webp'],
    home_support_collection_flatlay: ['02_home_support_collection_flatlay.png', 'inkmerge_apparel_collection_flatlay.webp'],
    shop_design_pet_city_club_tee_cap: ['03_shop_design_pet_city_club_tee_cap.png', 'pet_city_club_t_shirt_and_cap_mockup.webp'],
    shop_design_pet_city_varsity_tee: ['04_shop_design_pet_city_varsity_tee.png', 'pet_city_varsity_t_shirt_mockup.webp'],
    shop_design_family_trip_2026_blue_tee: ['05_shop_design_family_trip_2026_blue_tee.png', 'blue_shirt_with_bold_family_trip_design.webp'],
    customize_tee_your_design_here: ['06_customize_tee_your_design_here.png', 'customizable_t_shirt_product_mockup.webp'],
    embroidery_polo_cap_setup: ['07_embroidery_polo_cap_setup.png', 'folded_polo_and_branded_cap_setup.webp'],
    bulk_orders_folded_apparel_stack: ['08_bulk_orders_folded_apparel_stack.png', 'neatly_stacked_inkmerge_apparel_collection.webp'],
    quality_branding_collage: ['09_quality_branding_collage.png', 'modern_apparel_and_branding_collage.webp'],
    design_sheet_graphic_artwork: ['10_design_sheet_graphic_artwork.png', 'bold_graphic_design_sticker_mockup.webp']
  };

  function rawAsset(name) { return assets[name] || ''; }

  function asset(name) {
    var src = rawAsset(name);
    var pair = optimizedNames[name];
    if (!src || !pair) return src;
    return src.replace(pair[0], pair[1]);
  }

  function upgradeExistingImages() {
    Object.keys(optimizedNames).forEach(function (name) {
      var pair = optimizedNames[name];
      var replacement = asset(name);
      if (!replacement) return;
      Array.prototype.forEach.call(document.querySelectorAll('img[src*="' + pair[0] + '"]'), function (image) {
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = replacement;
        image.loading = image.loading || 'lazy';
        image.decoding = 'async';
      });
    });
  }

  function has(name) {
    var pair = optimizedNames[name];
    var html = document.documentElement.innerHTML;
    return html.indexOf(name) !== -1 || (pair && (html.indexOf(pair[0]) !== -1 || html.indexOf(pair[1]) !== -1));
  }

  function makeImage(name, alt, className) {
    var src = asset(name);
    if (!src) return null;
    var image = document.createElement('img');
    image.src = src;
    image.alt = alt || 'InkMerge apparel preview';
    image.width = 700;
    image.height = 700;
    image.loading = 'lazy';
    image.decoding = 'async';
    image.className = className || 'im-reference-img';
    image.style.objectFit = 'cover';
    return image;
  }

  function replaceSlot(selector, name, alt, className) {
    if (has(name)) return;
    var slot = document.querySelector(selector);
    var image = makeImage(name, alt, className);
    if (!slot || !image) return;
    slot.innerHTML = '';
    slot.appendChild(image);
  }

  function replaceCardImages(names) {
    var cards = Array.from(document.querySelectorAll('.card__img, .card__img--container, [data-product-card-default] .card__img'));
    names.forEach(function (item, index) {
      if (has(item.name)) return;
      var slot = cards[index];
      var image = makeImage(item.name, item.alt, 'card__img--reference');
      if (!slot || !image) return;
      var existing = slot.querySelector('img');
      if (existing) {
        existing.removeAttribute('srcset');
        existing.removeAttribute('sizes');
        existing.src = image.src;
        existing.alt = image.alt;
        existing.className = image.className;
      } else {
        slot.appendChild(image);
      }
    });
  }

  function addImageCard(parentSelector, name, alt, className) {
    if (has(name)) return;
    var parent = document.querySelector(parentSelector);
    var image = makeImage(name, alt, className || 'im-route-page__img');
    if (!parent || !image) return;
    var card = document.createElement('div');
    card.className = 'im-route-page__image-card im-cache-bridge-image-card';
    card.appendChild(image);
    parent.appendChild(card);
  }

  function run() {
    upgradeExistingImages();

    if (path === '/collections/shop-designs' || path === '/collections/newest-graphic-tees' || path === '/collections/new-drops') {
      replaceCardImages([
        { name: 'shop_design_pet_city_varsity_tee', alt: 'Pet City varsity tee mockup' },
        { name: 'shop_design_family_trip_2026_blue_tee', alt: 'Blue family trip graphic tee mockup' },
        { name: 'shop_design_pet_city_club_tee_cap', alt: 'Pet City club tee and cap mockup' }
      ]);
    }

    if (path.indexOf('/products/happy-first-day-of-school-abcd-graphic-tee') === 0) {
      var productMain = document.querySelector('.product__row, .product-page__product, [id*="product-page"]');
      if (productMain && !productMain.querySelector('.im-cache-bridge-pdp')) {
        var gallery = document.createElement('div');
        gallery.className = 'pdp-gallery--reference im-cache-bridge-pdp';
        [
          { name: 'shop_design_pet_city_varsity_tee', alt: 'Pet City varsity tee mockup' },
          { name: 'shop_design_pet_city_club_tee_cap', alt: 'Pet City club tee and cap mockup' },
          { name: 'shop_design_family_trip_2026_blue_tee', alt: 'Blue family trip graphic tee mockup' }
        ].forEach(function (item) {
          var image = makeImage(item.name, item.alt, 'pdp-gallery__img');
          if (image) gallery.appendChild(image);
        });
        if (gallery.childNodes.length) productMain.prepend(gallery);
      }
    }

    if (path === '/pages/logo-embroidery-bulk-orders') {
      window.location.replace('/pages/logo-embroidery');
      return;
    }

    if (path === '/pages/logo-embroidery') {
      replaceSlot('.im-quote-visual--embroidery', 'embroidery_polo_cap_setup', 'Folded polo and branded cap embroidery setup', 'im-quote-visual__img');
    }

    if (path === '/pages/bulk-orders') {
      replaceSlot('.im-quote-visual--bulk, .im-quote-visual', 'bulk_orders_folded_apparel_stack', 'Neatly stacked InkMerge apparel collection for bulk orders', 'im-quote-visual__img');
    }

    if (path === '/pages/faq') {
      addImageCard('.im-router-section, .im-router-page--help', 'design_sheet_graphic_artwork', 'Bold graphic design artwork sheet mockup', 'im-router-help-visual__img');
    }

    if (path === '/pages/inkmerge-pro') {
      replaceSlot('.im-router-page__visual--dtf, .im-router-page__visual', 'design_sheet_graphic_artwork', 'Bold graphic design artwork sheet mockup for InkMerge Pro', 'im-router-page__img');
    }

    if (path === '/pages/contact' || path === '/pages/contact-inkmerge') {
      addImageCard('.im-route-page__side, .im-route-page__split, .im-js-route-page__split', 'quality_branding_collage', 'InkMerge apparel and branding collage', 'im-route-page__img');
    }

    if (path === '/cart') {
      replaceSlot('.im-cart-page__empty-media', 'shop_design_pet_city_varsity_tee', 'Pet City varsity tee mockup', 'im-cart-page__empty-img');
      replaceCardImages([
        { name: 'shop_design_family_trip_2026_blue_tee', alt: 'Blue family trip graphic tee mockup' },
        { name: 'shop_design_pet_city_club_tee_cap', alt: 'Pet City club tee and cap mockup' },
        { name: 'home_support_collection_flatlay', alt: 'InkMerge apparel collection flatlay' }
      ]);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
  window.setTimeout(run, 800);
})();
